import React from 'react';
import Skeleton from 'react-loading-skeleton';
import {LOAN_CURRENCY_TYPE_USD, STATUS_NEW, STATUS_IN_PROGRESS, STATUS_APPROVED,STATUS_REJECTED,STATUS_PROCESSED, STATUS_CLOSED, LOAN_CURRENCY_TYPE_BHD ,AUDITOR_ROLE,LOAN_DELISTED ,LOAN_TECHNICAL_CLOSURE} from '../utilities';
import moment from "moment/moment";
import { useEffect,useState } from 'react';
import { decrypt } from '../utils';
import Cookies from 'js-cookie';
import { Form, Modal } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import axios from 'axios';
import { base_url } from '../utilities';
import { toast } from "react-toastify";

const TableData = (props) => {
  const [roleCode, setRoleeCode] = useState(() => {
    const storedRoleeCode = Cookies.get('role_code');
    return storedRoleeCode ? storedRoleeCode : '';
  });
  const [selectedRowReferenceNumber, setSelectedRowReferenceNumbe] = useState(null);
  const[showEditMark,setshowEditMark]=useState(true);
  const[showActionMArks,setShowActionMArks]=useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const handleImageClick = (rowReferenceNo) => {
    setSelectedRowReferenceNumbe(rowReferenceNo); 
    setshowEditMark(false); 
    setShowActionMArks(true); 
  };
  
  const handleActionMarkClick = () => {
    setShowActionMArks(false); 
    setshowEditMark(true); 
    setSelectedRowReferenceNumbe(null);
  };
  const[typedValue,setTypdValue]=useState(0);

const handleEditAmtPaid = (e, id) => {
  const { target } = e;
  const name = target.name;
  const strValue = e.target.value.replace(/,/g, "");
  if(!isNaN(strValue) && strValue.trim() !==''){
    const rawValue=Number(strValue);
    setTypdValue(rawValue);
    return;
  }
  setTypdValue(strValue);
};

const handleSubmitAmountTransfer=(row)=>{
  handleActionMarkClick();
  if( typeof typedValue==="string"){
    toast.warn("Enter a number");
  }
  else{
  const data={
     amount_transferred:typedValue,
    investor_id:row.investor_id,
    investor_reference_no:row.investor_reference_no
  }
  axios.post(base_url + "investor-master/update_amounttransfer_investor_master", data)
    .then(response => {
toast.success("Changes Saved", {
          toastId: 40,
        })})
    .catch(error => {
toast.error("Failed to save Changes", {
        toastId: 41,
      });    });
    }
setTimeout(()=>{
  window.location.reload();
},200)
}
  useEffect(()=>{
    if (roleCode) {
      try {
        const decryptedValueData = decrypt(roleCode);
        setRoleeCode(decryptedValueData);
      } catch (error) {
        console.error('Decryption error:', error);
      }
    }
  },[])
  
    let {data, columns, onImageClick, ltwo, loading, handleSort} = props;

    return (
        <>
         <thead className={`${window.location.pathname ==='/allservicerequests' ? '':'myloan_table_headers'}`}>
        <tr >
          {columns?.map((column) => (
            <th className='Cpointer' key={column.field}  onClick={() =>  handleSort(column.field ||column.date)}>{ltwo || loading ? <Skeleton width={100} height={15}/>:
            column.title !== 'Details' && column.title !== 'Actions' ? <div className='text-black text-start table_data_header_styl'> {column.title}&#9662;</div>: column.title
            
            }
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data?.map((row, index) => (
          <tr key={index}>
            {columns?.map((column, index) =>
              column.field === 'image' ? (
                <td key={index}
                data={column.datatopass}
                onClick={() => onImageClick(row)}
                className="indiv_loan_dtls"
                >
               { ltwo || loading ? <Skeleton width={100} height={15}/>:<img
                    
                    src={column.image}
                style={{height:"15px"}}

                    alt={row.name}
                    onClick={() => onImageClick(row)}
                    data={column.datatopass?column.datatopass:column}
                  />}
                    

                </td>
              ) : 
              
                column.field === 'status' ? 
                 (
                <td key={index}>{ltwo || loading ? <Skeleton width={100} height={15}/>:
                
                (row[column.field]) === STATUS_NEW ? <div style={{color:""}}>New </div>:
                (row[column.field]) === STATUS_IN_PROGRESS ? <div style={{color:"orange"}}>In Progress</div>:
                (row[column.field]) === STATUS_APPROVED ? <div style={{color:"blue"}}>Approved</div>:
                (row[column.field]) === STATUS_REJECTED ? <div style={{color:"Red"}}>Rejected</div>:
                (row[column.field]) === STATUS_PROCESSED ? <div style={{color:"Green"}}>Processed</div>:
                (row[column.field]) === STATUS_CLOSED ? <div style={{color:"grey"}}>Closed</div>:
                (row[column.field]) === LOAN_DELISTED ? <div style={{color:"grey"}}>Delisted</div>:
                (row[column.field]) === LOAN_TECHNICAL_CLOSURE ? <div style={{color:"grey"}}>Technical Closure</div>:
                (row[column.field]) === 'Approved' ? <div style={{color:"blue"}}>Approved</div>:
                (row[column.field]) === 'Rejected' ? <div style={{color:"Red"}}>Rejected</div>:
                (row[column.field]) === 'Assigned' ? <div style={{color:"blue"}}>Assigned</div>:
                (row[column.field]) === 'Processed' ? <div style={{color:"Green"}}>Processed</div>:
                (row[column.field]) === 'In Progress' ? <div style={{color:"orange"}}>In Progress</div>:
                (row[column.field]) === 'Closed' ? <div style={{color:"grey"}}>Closed</div>:
                (row[column.field]) === 'New' ? <div style={{color:""}}>New</div>:
                (row[column.field]) === 'Delisted' ? <div style={{color:"grey"}}>Delisted</div>:
                (row[column.field]) === 'Technical Closure' ? <div style={{color:"grey"}}>Technical Closure</div>:
                (row[column.field]) === 'Pending Investor Approval' ? <div style={{color:"blue"}}>Pending Investor Approval</div>:
                
                'No Status'
                }</td>

              ):
              column.field === 'status' && column.statusimg ==="image" ? 
                 (
                <td key={index}>{ltwo || loading ? <Skeleton width={100} height={15}/>:
                
                (row[column.field]) === STATUS_NEW ? <div style={{color:""}}>New </div>:
                (row[column.field]) === STATUS_IN_PROGRESS ? <div style={{color:"blue"}}>In Progress</div>:
                (row[column.field]) === STATUS_APPROVED ? <div style={{color:"Green"}}>Approved</div>:
                (row[column.field]) === STATUS_REJECTED ? <div style={{color:"Red"}}>Rejected</div>:
                (row[column.field]) === STATUS_PROCESSED ? <div style={{color:"Green"}}>Processed</div>:
                (row[column.field]) === LOAN_DELISTED ? <div style={{color:"grey"}}>Delisted</div>:
                (row[column.field]) === LOAN_TECHNICAL_CLOSURE ? <div style={{color:"grey"}}>Technical Closure</div>:
                (row[column.field]) === 'Approved' ? <div style={{color:"Green"}}>Approved</div>:
                (row[column.field]) === 'Rejected' ? <div style={{color:"Red"}}>Rejected</div>:
                (row[column.field]) === 'Assigned' ? <div style={{color:"blue"}}>Assigned</div>:
                (row[column.field]) === 'Processed' ? <div style={{color:"Blue"}}>Processed</div>:
                (row[column.field]) === 'In Progress' ? <div style={{color:"Orange"}}>In Progress</div>:
                (row[column.field]) === 'Closed' ? <div style={{color:"blue"}}>Closed</div>:
                (row[column.field]) === 'New' ? <div style={{color:""}}>New</div>:
                (row[column.field]) === 'Delisted' ? <div style={{color:"grey"}}>Delisted</div>:
                (row[column.field]) === 'Technical Closure' ? <div style={{color:"grey"}}>Technical Closure</div>:
                
                'No Status'
                }</td>

              ):
              column.field === 'loan_tenure' ?
              (
                <td key={index}>{
                  ltwo || loading ? <Skeleton width={100} height={15}/>:
                  row[column.field] === 1 ?
                  row[column.field] + " Month" : 
                  row[column.field] + " Months"
                  
                  }</td>
              ):column.type ==='eye' ? (
                <td key={index}
                data={column.datatopass}
                onClick={() => onImageClick(row)}
                className={`${row.status !=='New' && row.status !=='In Progress' && row.status !==LOAN_DELISTED && row.status !==LOAN_TECHNICAL_CLOSURE ? 'hidden_eye_style' : "indiv_loan_dtls"}`}
                >
               {/* { ltwo || loading ? <Skeleton width={100} height={15}/>:<img
                    src={row.status ==='New'? column.image:'./images/eye.svg'}
                    alt={row.name}
                    onClick={() => onImageClick(row)}
                    data={column.datatopass?column.datatopass:column}
                  />} */}

                 {ltwo || loading ? <Skeleton width={100} height={15} /> :
                            (() => {
                              // Check if status is "In Progress" and updated_date_time_number is MORE THAN 30 days before current date
                              const isInProgress = row.status === 'In Progress';
                              const isDelisted = row.status === LOAN_DELISTED;
                              const isTechnicalClosure = row.status === LOAN_TECHNICAL_CLOSURE;
                              const lastActivityDate = row.updated_date_time_number ? new Date(row.updated_date_time_number) : null;
                              const currentDate = new Date();
                              const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
                              const isMoreThanThirtyDaysBefore = lastActivityDate && (currentDate - lastActivityDate > thirtyDaysInMs);

                              if (isInProgress || isDelisted || isTechnicalClosure ) {
                                // Render a small button instead of the Eye icon
                                return (
                                  <img
                                    src={row.status === 'In Progress' || row.status === LOAN_DELISTED || row.status === LOAN_TECHNICAL_CLOSURE ? column.image : './images/eye.svg'}
                                    alt={row.name}
                                    onClick={() => {
                                      setSelectedRowData(row);
                                      setShowViewModal(true);
                                      if (onImageClick) onImageClick(row);
                                    }}
                                    data={column.datatopass ? column.datatopass : column}
                                  />
                                );
                              } 
                              
                             
                              else {
                                // Render the original Eye icon
                                return (
                                  <img
                                    src={row.status === 'New' ? column.image : './images/eye.svg'}
                                    alt={row.name}
                                    onClick={() => onImageClick(row)}
                                    data={column.datatopass ? column.datatopass : column}
                                  />
                                );
                              }
                            })()
                          }
                    

                </td>):column.field ==='updated_date_time_number' ? (
                <td key={index}
                data={column.datatopass}
                
                >
               { ltwo || loading ? <Skeleton width={100} height={15}/>:(row[column.field]) === undefined ?
                  '-': moment(row[column.field]).format( "D MMM YYYY H:mm" )}
                    

                </td>):column.field ==='tenure_date' || column.field === 'created_date_time'? (
                <td key={index}
                
                >
               { ltwo || loading ? <Skeleton width={100} height={15}/>:(row[column.field]) === undefined ?
                  '-': moment(row[column.field]).format( "D MMM YYYY" )}
                    

                </td>)

               :column.field ==='loan_amount' ||column.field ==='final_loan_amount' || column.field === 'total_loan_amount' || column.field === 'tenure_amount' ||column.field === 'penalty_amount' || column.field === "paid_amount" || column.field === "total_repaid" || column.field === 'net_returns' || column.field === 'profit' || column.field === 'committed_principal' || column.field === 'total_invested' || column.field === "admin_request_loan_amount"? (
                <td key={index} style={{minWidth:"9rem"}}>
               { ltwo || loading ? <Skeleton width={100} height={15}/>:(row[column.field]) !== undefined ?
                                  //  (row[column.currency]) !==''|| (row[column.currency])!== undefined || (row[column.currency])!==null ? (row[column.currency]) === LOAN_CURRENCY_TYPE_USD? "$ "+  (Number(row[column.field]).toLocaleString()) : "BHD " +  (Number(row[column.field]).toLocaleString()):(row[column.currency]) === LOAN_CURRENCY_TYPE_BHD? "BHD "+  (Number(row[column.field]).toLocaleString()):'' :'-'}

                                  (row[column.currency]) !== '' || (row[column.currency]) !== undefined || (row[column.currency]) !== null ?
                                    (row[column.currency]) === LOAN_CURRENCY_TYPE_USD ? (
                                      <div>
                                        <div style={{ fontWeight: 500 }}>
                                          BHD {Number(row[column.field + '_bhd'] ?? row[column.field]).toLocaleString()}
                                        </div>
                                        <div style={{ fontSize: 15, color: '#555', marginTop: 2 }}>
                                          $ {Number(row[column.field]).toLocaleString()}
                                        </div>
                                      </div>
                                    ) : "BHD " + (Number(row[column.field]).toLocaleString())
                                    : (row[column.currency]) === LOAN_CURRENCY_TYPE_BHD ? "BHD " + (Number(row[column.field]).toLocaleString()) : '' : '-'}

                </td>)
                :column.field === 'amount_transferred'?(
                  <td key={index}
                  className="txt"
                >
                  {ltwo || loading ? <Skeleton width={100} height={15}/>:<div class="d-flex gap-1">
                  <div>
                      {(row[column.field]) !== undefined ? 
  (row[column.currency]) !== '' || (row[column.currency]) !== undefined || (row[column.currency]) !== null ? 
    (row[column.currency]) === LOAN_CURRENCY_TYPE_USD ? "$ " 
    : "BHD " 
  : '' 
: '-'}
                   </div>
                   <div className="form-group">
      <Form.Control
        type="text"
        className="rounded shadow-ben"
        id="bennefin"
        name="amount_transferred"
        required
        role="presentation"
        autoComplete="off"
        disabled={selectedRowReferenceNumber !== row.investor_reference_no}  
        defaultValue={(Number(row.amount_transferred)).toLocaleString()}
        onChange={(e, id) => handleEditAmtPaid(e, row.investor_reference_no)}
      />
  </div>
                    
  {selectedRowReferenceNumber !== row.investor_reference_no && (
          <img
            src="./images/pen.svg"
            alt=""
            onClick={() => handleImageClick(row.investor_reference_no)}
          />
        )}
                     
      {selectedRowReferenceNumber === row.investor_reference_no && (
  <div className="form-group">
    {showActionMArks &&
        <div className='d-flex justify-content-center align-items-center gap-2 pt-2'>
      <img
      style={{ width: "13px" }}
      src={"./images/rightMark.svg"}
      alt=""
      onClick={()=>handleSubmitAmountTransfer(row)}
      /> 
      <img
        style={{ width: "13px" }}
        src="./images/cancelMark.svg"
        alt=""
        onClick={handleActionMarkClick}
      />
      </div>}

  </div>
) }
</div>
}
                </td>
                ):column.field ==='bennefin_roi'|| column.field === 'avg_monthly_return' || column.field === 'principal_repaid_percentage' || column.field === 'investor_roi' ? (
                <td key={index}>
               { ltwo || loading ? <Skeleton width={100} height={15}/>:(row[column.field]) === undefined || (row[column.field]) === '' || (row[column.field]) === null ?
                  '-': (row[column.field] === 0 ? row[column.field] : row[column.field] + "%")}
                    

                </td>):column.field ==='loan_sr_no'? (
                <td key={index}>
               { ltwo || loading ? <Skeleton width={100} height={15}/>:(index + 1)}
                    

                </td>):column.field === 'loan_image' ? (
                <td key={index}
                data={column.datatopass}
                // onClick={() => onImageClick(row)}
                >
               { ltwo || loading ? <Skeleton width={100} height={15}/>:
               row.status === STATUS_PROCESSED || row.status === STATUS_CLOSED ||row.status==="Closed" || row.status==="Processed"? <img
                className="indiv_loan_dtls"
                    src={column.image}
                    alt={row.name}
                    onClick={() => onImageClick(row)}
                    data={column.datatopass?column.datatopass:column}
                    style={{
                      pointerEvents: roleCode === AUDITOR_ROLE ? 'none' : 'auto',
                      opacity: roleCode === AUDITOR_ROLE ? 0.5 : 1,
                    }}
                  />:'-'}
                    

                </td>
              ) :
                
               (
                <td key={index}>{ltwo || loading ? <Skeleton width={100} height={15}/>:
                  (row[column.field]) === undefined ?
                  '-': (row[column.field])
                  }</td>
              )
            )}
          </tr>
        ))}
      </tbody>

      {showViewModal && (
        <ViewPerticularInvDetails
          show={showViewModal}
          onHide={() => setShowViewModal(false)}
          data={selectedRowData}
        />
      )}
      </>
    );
};

export default TableData;




export const ViewPerticularInvDetails = (props) => {
  let { data } = props;

  const handleClose = () => {
    props.onHide();
  };
  
  const handleDelisting = async (id, type) => {
   
    try {
      const response = await axios.post(base_url + "service-request-trx/delist", {
        loan_id: data.loan_id,
        status: id
      });
      console.log(response, "response");
      
      if (response.status == 200) {
        if (type === 'delist') {
          toast.success("Delisted Successfully", {
            toastId: 4,
          });
          setTimeout(() => {
            window.location.reload();
          }, 800);
        } else if (type === 'technical_closure') {
          toast.success("Technical Closure Successful", {
            toastId: 5,
          });
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      }
    } catch (error) {
      console.error(`Error in ${type}:`, error);
      alert(`An error occurred during ${type === 'delist' ? 'delisting' : 'technical closure'}. Please try again.`);
    }
  };




  const checkAdminSentTermsToBusiness = () => {
    if (!data?.investor_interests?.length) return false;

    let isarray =[]
    const allTerms = data.investor_interests
      .map(item => {
        isarray.push(item.is_admin_sent_terms_to_business);
      });
  
    const hasZero = isarray.includes(1);
  
    return !hasZero; 
  };
  

  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        onHide={handleClose}
        closeButton
        className="modal_title"
        style={{ height: "55px" }}
      >
        <Modal.Title id="example-custom-modal-styling-title">
          <div className=" ps-2 d-flex justify-content-between">
            <div className="heading_new_loan ">
              <h5 className="mb-0 me-5 pe-5">View Details</h5>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 py-2" style={{ height: "28rem" }}>
        <div className="container p-0 pb-3">
          <div className="row">
            <div className="container ps-0 d-flex mb-3">
              <div className="col-lg-4  mb-3 me-1">
                <p className="text_ststrong ">Business Name</p>
                <span className="bolder_textstrong ">
                  {data.business_name === undefined ? "-" : data.business_name}
                </span>
              </div>
              <div className="col mb-4">
                <p className="text_ststrong ">Investor Name</p>
                <span className="bolder_textstrong ">
                  {data.investor_interests && data.investor_interests.length > 0 
                    ? data.investor_interests.map((item) => 
                        item.investorDetails?.investor_name || "-"
                      ).join(", ")
                    : "-"}
                </span>
              </div>
            </div>
            <div className="col ">
              
              <div className="mb-4">
                <p className="text_st ">Loan type</p>
                <span className="bolder_text ">
                  {data.loan_type_name === undefined
                    ? "-"
                    : data.loan_type_name}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Loan Reference No.</p>
                <span className="bolder_text ">
                  {data.loan_reference_number === undefined
                    ? "-"
                    : data.loan_reference_number}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Interest Frequency</p>
                <span className="bolder_text ">
                  {data.investor_request.interest_frequency === undefined ||
                  data.investor_request.interest_frequency === ""
                    ? "-"
                    : data.investor_request.interest_frequency}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Processing Fee</p>
                <span className="bolder_text ">
                  {data.investor_request.processing_fees === undefined ||
                  data.investor_request.processing_fees === ""
                    ? "-"
                    : data.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_BHD
                    ? "BHD " + data.investor_request.processing_fees
                    : data.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_USD
                    ? "$ " + data.investor_request.processing_fees
                    : "-"}
                </span>
              </div>
            </div>

            <div className="col">
              <div className="mb-4">
                <p className="text_st ">Requested Tenure Period</p>
                <span className="bolder_text ">
                  {data.investor_request.admin_request_loan_tenure === undefined ||
                  data.investor_request.admin_request_loan_tenure === ""
                    ? "-"
                    : data.investor_request.admin_request_loan_tenure === 1
                    ? data.investor_request.admin_request_loan_tenure + " Month"
                    : data.investor_request.admin_request_loan_tenure > 1
                    ? data.investor_request.admin_request_loan_tenure + " Months"
                    : "-"}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Amount Borrowed</p>
                <span className="bolder_text ">
                  {data.loan_amount === undefined || data.loan_amount === ""
                    ? "-"
                    : data.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_BHD
                    ? "BHD " + Number(data.loan_amount).toLocaleString()
                    : data.admin_request_loan_currency ===
                      LOAN_CURRENCY_TYPE_USD
                    ? "$ " + Number(data.loan_amount).toLocaleString()
                    : "-"}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Profit Rate</p>
                <span className="bolder_text ">
                  {data.investor_request
                    .investor_roi === undefined || data.investor_request
                    .investor_roi === ""
                    ? "-"
                    : data.investor_request
                    .investor_roi + "%"}
                </span>
              </div>
             
            </div>
            <div className="col">
              <div className="mb-4">
                <p className="text_st ">Status</p>
                <span className="bolder_text ">
                    {data.status === LOAN_DELISTED ? "Delisted" : data.status === LOAN_TECHNICAL_CLOSURE ? "Technical Closure" : data.status}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Loan Purpose</p>
                <span className="bolder_text ">
                  {data.loan_purpose === undefined || data.loan_purpose === ""
                    ? "-"
                    : data.loan_purpose}
                </span>
              </div>
              <div className="mb-4">
                <p className="text_st ">Processing Fee Type</p>
                <span className="bolder_text ">
                  {data.investor_request.processing_fees_type === undefined ||
                  data.investor_request.processing_fees_type === ""
                    ? "-"
                    : data.investor_request.processing_fees_type}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex  ps-3 pe-3">
        <div>
          <button
            className="btn btn_background mx-2 px-3 py-2"
            onClick={handleClose}
          >
            Close
          </button>

          {data.investor_interests.length>0 ? (
            data.investor_interests.length >0 && data.status == "In Progress" && checkAdminSentTermsToBusiness() ?
            <button
              className="btn btn-primary mx-2 px-3 py-2"
              onClick={() => handleDelisting(9, 'technical_closure')}
            >
               Technical Closure
           
            </button> : null
            ) :  data.investor_interests.length == 0 && data.status == "In Progress" ?
           
          <button
          className="btn btn-primary mx-2 px-3 py-2"
          onClick={() => handleDelisting(8, 'delist')}
          >
            Delisting
        </button> : null
        }
        </div>
      </Modal.Footer>
    </Modal>
  );
};